module.exports = "<div class=\"form-group\">\n  <label class=\"col-sm-2 control-label\">{{displayName}}</label>\n  <div class=\"col-sm-10\">\n    <ng-select  [multiple]=\"multiple\"\n                [items]=\"items\"\n                [disabled]=\"form.controls[field].disabled\"\n                [active]=\"active\"\n                (data)=\"refreshValue($event)\"\n                (selected)=\"selected($event)\"\n                (removed)=\"removed($event)\"\n                placeholder=\"Nothing selected\"></ng-select>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/formcontrol-select/formcontrol-select.component.html
// module id = 303
// module chunks = 0 1